export const PROCESSING_NFC_CARD_SUCCESS = "PROCESSING_NFC_CARD_SUCCESS";
export const PROCESSING_NFC_CARD_FAILURE = "PROCESSING_NFC_CARD_FAILURE";

export const COMPLETED_NFC_CARD_SUCCESS = "COMPLETED_NFC_CARD_SUCCESS";
export const COMPLETED_NFC_CARD_FAILURE = "COMPLETED_NFC_CARD_FAILURE";

export const ALL_NFC_CARD_SUCCESS = "ALL_NFC_CARD_SUCCESS";
export const ALL_NFC_CARD_FAILURE = "ALL_NFC_CARD_FAILURE";

export const UPDATE_NFC_CARD_STATUS_SUCCESS =
  "UPDATE_NFC_CARD_STATUS_SUCCESS";
export const UPDATE_NFC_CARD_STATUS_FAILURE =
  "UPDATE_NFC_CARD_STATUS_FAILURE";

export const MANUAL_NFC_CARD_SUCCESS = "MANUAL_NFC_CARD_SUCCESS";
export const MANUAL_NFC_CARD_FAILURE = "MANUAL_NFC_CARD_FAILURE";
